import { render, staticRenderFns } from "./BalanceAlertPopUp.vue?vue&type=template&id=aaaae7c4&scoped=true"
import script from "./BalanceAlertPopUp.vue?vue&type=script&lang=ts"
export * from "./BalanceAlertPopUp.vue?vue&type=script&lang=ts"
import style0 from "./BalanceAlertPopUp.vue?vue&type=style&index=0&id=aaaae7c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaae7c4",
  null
  
)

export default component.exports